import React, { useEffect, useState } from 'react';
import { Label } from 'reactstrap';
import VideosPreview from './VideosPreview';
import { VideoPreviewType } from '../../../utils/Types';
import MediaThumbnailUpload from '../../../components/MediaThumbnailUpload';
import { toast } from 'react-toastify';
import {
  alertPopupToggle,
  defaultData,
  handleSubmit,
  onRemove,
} from './welcomeVideosHelper';
import { useAppDispatch, useAppSelector } from '../../../store/redux-hooks';
import {
  getWelcomeVideosList,
  welcomeVideosSelector,
} from '../../../features/welcomeVideosSlice';
import CenterSpinner from '../../../components/CenterSpinner';
import AlertPopUP from '../../modals/AlertPopUp';
import { API_STATUS, maxFilesInAdminSettings } from '../../../utils/Constant';
import { useLoader } from '../../../loader/LoaderProvider';
const WelcomeVideos: React.FunctionComponent = () => {
  const [videos, setVideos] = useState<VideoPreviewType[]>([]);
  const [data, setData] = useState(defaultData);
  const { showLoader, setShowLoader } = useLoader();
  const [showAlertPopUp, setShowAlertPopUp] = useState<boolean>(false);
  const [removeMediaId, setRemoveMediaId] = useState<any>('');
  const dispatch = useAppDispatch();
  const videosList = useAppSelector(welcomeVideosSelector).videos;
  const apiStatus = useAppSelector(welcomeVideosSelector).status;

  const handleCancel = () => {
    setData(defaultData);
  };

  useEffect(() => {
    dispatch(getWelcomeVideosList());
  }, []);

  useEffect(() => {
    if (videosList?.length) {
      const videoList: VideoPreviewType[] = videosList.map((video) => {
        return {
          url: video.bannerUrl,
          id: video.bannerId,
          name: video.bannerTitle,
          thumbnail: video.bannerThumbnail,
          createdOn: video.createdOn,
          order: video.bannerOrder,
        };
      });
      setVideos(videoList);
    } else {
      setVideos([]);
    }
  }, [videosList]);

  useEffect(() => {
    if (apiStatus === API_STATUS.FAILED || apiStatus === API_STATUS.SUCCEEDED) {
      setShowLoader(false);
    } else {
      setShowLoader(true);
    }
  }, [apiStatus]);

  return (
    <div className="ml-4">
      <Label className="text-heading">Welcome Videos</Label>
      <div className="container-parent task-item-parent-view bg-white ">
        <MediaThumbnailUpload
          data={data}
          onSubmit={() => {
            handleSubmit(data, setData, {
              setShowLoader,
              dispatch,
              toast,
            });
          }}
          setData={setData}
          onCancel={handleCancel}
          mediaSupportedFiles={['.mp4']}
          disabled={videos?.length >= maxFilesInAdminSettings.welcomeVideos}
        />
        <div className="mt-3">
          <VideosPreview
            videos={videos}
            handleRemove={(id: number | string) => {
              onRemove(id, setShowAlertPopUp, setRemoveMediaId);
            }}
          />
        </div>
      </div>
      <CenterSpinner showLoader={showLoader} />
      {showAlertPopUp && (
        <AlertPopUP
          isOpen={showAlertPopUp}
          toggle={(action: string) => {
            alertPopupToggle(
              action,
              {
                removeMediaId,
                setShowLoader,
                dispatch,
                toast,
              },
              setShowAlertPopUp,
              setRemoveMediaId
            );
          }}
        />
      )}
    </div>
  );
};

export default WelcomeVideos;
